export default __webpack_public_path__ + "static/media/docs-mobile.dee7da74.jpg";